
<template>
    <div class="model-content">
        <div class="mode20" :class="(posterList.lang == 'ug' || !posterList.lang) ? 'model_ug' : 'model_zh'">
            <div class="img-box">
                <img v-if="posterList.lang == 'ug' || !posterList.lang" style="width: 100%;" :src="moban_list.url_ug" />
                <img v-if="posterList.lang == 'zh'" style="width: 100%;" :src="moban_list.url_zh" />
            </div>
            <div class="merchant_img">
                <img :src="posterList.merchant_img" alt="">
            </div>
            <div class="merchant_qrcode">
                <img :src="posterList.merchant_qrcode" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "model_20",
    data() {
        return {
            posterList: {},
            moban_list: {
                url_zh: require('../../img/poster/model_20_zh.jpg'),
                url_ug: require('../../img/poster/model_20_ug.jpg'),
            },
        };
    },
    created() {
        this.canvasfortitle(this.$route.query.merchant_name, this.$route.query);
    },
    methods: {
        canvasfortitle(merchant_name, query) {
            let res_name = merchant_name.replaceAll('(', '-')
            res_name = res_name.replaceAll('（', '-')
            res_name = res_name.replaceAll(')', ' ')
            res_name = res_name.replaceAll('）', ' ')
            this.posterList = query;
            this.posterList['merchant_name'] = res_name;
            console.log(this.posterList);
        },
    },
};
</script>
  
<style scoped>
.model-content {
    width: 352px;
    height: 632px;
    display: flex; 
    justify-content: center;
    position: relative;
    margin: auto;
}

.mode20 {
    width: 352px;
    height: 632px;
    position: relative;
}

.model_ug {
    direction: rtl;
}

.model_zh {
    direction: ltr;
}

.img-box {
    width: 100%;
    height: 100%;
}

.merchant_img {
    position: absolute;
    top: 126px;
    left: 114px;
    width: 124px;
    height: 124px;
    border-radius: 6px;
    overflow: hidden;
}

.merchant_img img {
    width: 100%;
    height: 100%;
}

.merchant_qrcode {
    position: absolute;
    top: 285px;
    left: 111px;
    width: 130px;
    height: 130px;
    background-color: #fff;
    border-radius: 50%;
    overflow: hidden;
    box-sizing: border-box;
}

.merchant_qrcode img {
    width: 100%;
    height: 100%;
}
</style>